/**
 * @generated SignedSource<<03b72aaeb6993b70a9f7f889b8c2015c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TestAccountActionsQuery$variables = {
  accountId: number;
};
export type TestAccountActionsQuery$data = {
  readonly account: {
    readonly account_type: string;
    readonly alternative_account: {
      readonly account_type: string;
      readonly id: number;
    } | null | undefined;
    readonly id: number;
    readonly last_copied: string | null | undefined;
  } | null | undefined;
};
export type TestAccountActionsQuery = {
  response: TestAccountActionsQuery$data;
  variables: TestAccountActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_type",
  "storageKey": null
},
v3 = [
  {
    "alias": "account",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "accountId"
      }
    ],
    "concreteType": "accounts",
    "kind": "LinkedField",
    "name": "accounts_by_pk",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "last_copied",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "alternative_account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TestAccountActionsQuery",
    "selections": (v3/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TestAccountActionsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5acb8efe507669385d9a6c20453efda9",
    "id": null,
    "metadata": {},
    "name": "TestAccountActionsQuery",
    "operationKind": "query",
    "text": "query TestAccountActionsQuery(\n  $accountId: Int!\n) {\n  account: accounts_by_pk(id: $accountId) {\n    id\n    account_type\n    last_copied\n    alternative_account {\n      id\n      account_type\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27be916d7dc427b632683d0468a63089";

export default node;
